import React, { useEffect, useState } from 'react'
import useFormFields from 'src/hooks/useFormFields';
import MultiInputSingle from './MultiInputSingle';
import usePersistantState from 'src/hooks/usePersistantState';

export default function MultiInput({ name, width, singleInputCount, inputPlaceholders }) {
    const { fields, handleChange } = useFormFields({}, name)
    const [inputCount, setInputCount] = usePersistantState(`${name}InputCount`, 1);
    let multiInput = [];
    const addInput = () => {
        setInputCount(inputCount + 1)
    }
    const handleDelete = (id) => {
        setInputCount(inputCount - 1);
    
    }
    for (let i = 0; i < inputCount; i++) {
        multiInput.push(<MultiInputSingle
            inputPlaceholders={inputPlaceholders}
            inputCount={singleInputCount}
            key={i}
            id={i}
            name={name}
            fields={fields}
            handleChange={handleChange}
            handleDelete={handleDelete}
            width={width}
            isLast={inputCount == i + 1 && i != 0 ? true : false}
        />);
    }

    return (
        <>
            <div>
                {multiInput}
            </div>
            <div className="flex items-center mb-5">
                <div className="inline-block text-right text-gray-500"></div>
                <button onClick={addInput}
                    className="flex w-[250px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300">
                    <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">+</span>
                    افزودن مورد جدید
                </button>
            </div>
        </>
    )
}
